var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vs-con-loading__container",attrs:{"id":"loading-cells"}},[_c('cell-sidebar',{attrs:{"cellId":_vm.cellId},on:{"reload":_vm.handleSearch}}),_c('vs-card',[_c('cell-table',{attrs:{"data":_vm.cells},on:{"add":_vm.handleAdd,"edit":_vm.handleEdit,"delete":_vm.handleDelete,"search":_vm.handleSearch}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }